<template>
  <ValidationProvider ref="validate" :vid="vid" :name="label" :rules="rules" v-slot="{ errors }">
    <v-text-field
      ref="input"
      class="text-field"
      v-model="model"
      :type="type"
      :label="label"
      :placeholder="placeholder"
      :outlined="outlined"
      :filled="filled"
      :append-icon="icon"
      :disabled="disabled"
      :readonly="readonly"
      :error-messages="errors[0]"
      @keydown="onKeyDown"
      @input="$emit('update:model', model);"
      @click:append="$emit('append')"
    ></v-text-field>
  </ValidationProvider>
</template>
<script>
export default {
  name: 'TextField',
  props: {
    vid: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    outlined: {
      type: Boolean,
      default: false
    },
    filled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Object,
      default: null
    },
    value: {
      type: [String, Number],
      default: null
    },
    keydown: {
      type: Function,
      default: null
    }
  },
  watch: {
    value(value) {
      this.model = value;
    }
  },
  created() {
    this.model = this.value;

    if (this.rules) {
      this.validated = false;
    }
  },
  mounted() {
    //emit errors
    this.$refs.validate.$watch('errors', value => {
      this.$emit('onError', value[0]);
    });
  },
  methods: {
    //events
    onKeyDown(event) {
      if (this.keydown) {
        const response = this.keydown(event, this);
        if (!response) {
          event.preventDefault();
          return;
        }
      }
    },
    //misc
    validate() {
      if (0 >= this.$refs.validate.errors.length) {
        return true;
      } else {
        return false;
      }
    },
    focus() {
      this.$refs.input.focus();
    }
  },
  data() {
    return {
      model: '',
      validated: true
    };
  }
};
</script>
